<template>
    <div class="schedule-tab">
        <div class="tab-hd">
            <div class="u-btn" v-for="(item,index) in config.tab_hd"
            :key="index"
            :class="[{act : index == now},'t-' + (index + 1)]"
            @click="now=index"></div>
        </div>

        <div class="tab-view">
            <div class="tab-container" v-if="ready">
                <ul v-if="config.tab_bd[now] && config.tab_bd[now].length">
                    <li class="s-item" v-for="(item,index) in config.tab_bd[now]" :key="index">
                        <p>{{ item.startTime.substring(0,10) }}</p>
                        <p>{{ item.group }}</p>
                        <div class="image-preview">                           
                            <el-image 
                                style="width: 100%; height: 100%"
                                :src="require('../assets/images/sample.png')" 
                                :preview-src-list="[item.image]">
                            </el-image>
                        </div>                    
                    </li>
                </ul>
                <div class="tbc" v-else></div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .tab-hd{
        display: flex;
        justify-content: space-between;
        padding: 0 45px;
    }

    .tab-hd .u-btn{
        width: 403px;
        height: 63px;
        background-position: center;
        background-repeat: no-repeat;
    }

    .u-btn.t-1{
        background-image: url(../assets/images/tab-r-1.png);
    }

    .u-btn.t-1.act{
        background-image: url(../assets/images/tab-r-1-act.png);
    }    

    .u-btn.t-2{
        background-image: url(../assets/images/tab-r-2.png);
    }
    
    .u-btn.t-2.act{
        background-image: url(../assets/images/tab-r-2-act.png);
    }
    
    .tab-view{
        position: relative;
        width: 1194px;
        height: 366px;
        margin: 20px auto 0;
        background-image: url(../assets/images/bg-com.png);
    }

    .tab-view ul{
        display: flex;
        flex-wrap: wrap;
        padding-top: 58px;
        padding: 58px 45px 0;
    }

    .s-item{
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 222px;
        height: 81px;
        padding: 5px 0;
        margin: 0 27px 60px;
        background-image: url(../assets/images/com-item.png);
        font-size: 20px;
        color: #fff4ae;
        box-sizing: border-box;
    }

    .s-item p{
        width: 100%;
        text-align: center;
    }

    .image-preview{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
    }

    .tab-view .tbc{
        position: absolute;
        width: 197px;
        height: 46px;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        background-image: url(../assets/images/icon-tbc.png);
    }
</style>

<script>
export default {
    data (){
        return {
            config : {
                tab_hd : ['正赛奖励','娱乐赛奖励'],
                tab_bd : [],
            },
            now : 0,
            tag : ['dianfeng','zhuangbei'],
            ready : false,
        }
    },
    created (){
        this.get_schedule_info();
        console.log(this.config.tab_bd[this.now]);
    },
    methods : {
        get_schedule_info (){
            var _this = this;
            this.$axios.get(this.$ajax_url_map.matchlist)
            .then(res => {
                if(res.data.code == this.$ajax_code.success){
                    _this.ready = true;
                    for(var i = 0;i < _this.config.tab_hd.length;i++){
                        var temp = res.data.data.filter(function(e){
                            return e.period == _this.tag[i];
                        });
                        
                        _this.config.tab_bd[i] = temp.length ? temp[0].groups : [];
                    }
                }
                else{
                    this.$message.error('赛程模块：数据请求失败，请稍后再试');
                }
            });
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/scheduleTab.vue